import React from 'react'

const Slug = textToReplace => {
	return textToReplace.replace('_', ' ')
}
export default Slug
